import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

const type = 'DraggableRow';
/**
 * draggable row
 * @param {func} param0.index row index
 * @param {func} param0.moveRow move row function
 * @param {string} param0.className class name
 * @param {object} param0.style style
 * @param {array} param0.selectedIndices selected row indices array
 * @param {func} param0.moveRows move multiple rows function
 * @param {object} param0.restProps other props
 * @returns 
 */
const DraggableRow = ({ index, moveRow, className, style, selectedIndices = [], moveRows, disableDrag = false, ...restProps }) => {
  const ref = React.useRef();
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item) => {
      // item: { index, type, selectedIndices }
      if (selectedIndices.includes(item.index) && typeof moveRows === 'function') {
        const dragIndices = [item.index];
        let addFlag = true, deleteFlag = true, position = 1
        while (addFlag || deleteFlag) {
          if (addFlag && selectedIndices.includes(item.index + position)) {
            dragIndices.push(item.index + position);
          } else {
            addFlag = false;
          }

          if (deleteFlag && selectedIndices.includes(item.index - position)) {
            dragIndices.unshift(item.index - position);
          } else {
            deleteFlag = false
          }

          position++;
        }
        if (dragIndices.includes(index)) {
          return;
        }
        moveRows(dragIndices, index);
      } else {
        moveRow(item.index, index);
      }
    },
  });
  const [, drag] = useDrag({
    type: type,
    item: { index, type },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drop(drag(ref));

  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{ cursor: disableDrag ? 'default' : 'move', ...style }}
      {...restProps}
    />
  );
};

export default DraggableRow;